module.exports = __webpack_public_path__ + "img/wp-existing-habit-card11.14b42ba9.jpg";